import { render, staticRenderFns } from "./vehicleType.vue?vue&type=template&id=6135ed0a&scoped=true&"
import script from "./vehicleType.vue?vue&type=script&lang=js&"
export * from "./vehicleType.vue?vue&type=script&lang=js&"
import style0 from "./vehicleType.vue?vue&type=style&index=0&id=6135ed0a&prod&lang=less&scoped=true&"
import style1 from "./vehicleType.vue?vue&type=style&index=1&id=6135ed0a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135ed0a",
  null
  
)

export default component.exports